/*
 * decaffeinate suggestions:
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';
import _ from 'underscore';

import Tags from 'components/Tags';
import {FolderSummary} from 'constants/FolderConstants';
import {Strand} from 'constants/MolbioConstants';
import {SequenceSummaryWithoutPermissions} from 'constants/SequenceConstants';
import * as selectables from 'molbio/maps/selectables/Selectables';
import {SelectableAttributes} from 'molbio/maps/selectables/Selectables';

class Sequence extends Backbone.Model {
  static initClass(): void {
    this.prototype.urlRoot = '/1/api/sequences';
  }

  bases(): string {
    return this.get('bases');
  }

  folder(): FolderSummary {
    return this.get('folder');
  }
}
Sequence.initClass();

interface TagSequenceAttributes {
  id: string;
  status: string;
  _sequence: Sequence;
}

class TagSequence extends selectables.Model {
  // Simpler sequence that just supports tag editing.
  override defaults(): Partial<SelectableAttributes> & {visible: boolean} {
    // eslint-disable-next-line no-restricted-syntax
    return _.extend(super.defaults(), {visible: true});
  }

  folder(): FolderSummary {
    return this.get('_sequence').folder();
  }

  override initialize(): void {
    this.set({tags: new Tags(this.get('_sequence').get('tags'), {sequenceID: this.id})});
  }

  override parse(data: SequenceSummaryWithoutPermissions & {status: string}): TagSequenceAttributes {
    return {
      id: data.id,
      status: data.status,
      _sequence: new Sequence(data, {parse: true}),
    };
  }

  override start(): number {
    throw new Error('Not implemented!');
  }

  override end(): number {
    throw new Error('Not implemented!');
  }

  override strand(): Strand {
    throw new Error('Not implemented!');
  }
}

export default TagSequence;
